import { adminAiSpendByUserSchema } from '@steado/admin-contract/ai-ops';
import { queryOptions } from '@tanstack/react-query';

import type { ApiClient } from '@/lib/api/client';

import type { AiSpendSearch } from './ai-spend-search';

/**
 * The spend ranking.
 *
 * A ranking, not a page — the API says so and refuses a cursor: the sort key
 * is an aggregate that moves between requests, so paging over it would skip
 * and repeat people. The screen asks for a bigger slice instead.
 */
export const AI_SPEND_LIMIT = 50;

export function aiSpendQueryOptions(api: ApiClient, search: AiSpendSearch) {
  const params = new URLSearchParams({
    days: String(search.days),
    limit: String(AI_SPEND_LIMIT),
    sort: search.sort,
  });
  if (search.entitlement !== undefined) params.set('entitlement', search.entitlement);
  if (search.search !== undefined) params.set('search', search.search);

  return queryOptions({
    queryKey: ['admin', 'ai-spend', search.days, search.sort, search.entitlement, search.search],
    queryFn: () =>
      api.request({
        path: `/admin/ai/spend-by-user?${params.toString()}`,
        schema: adminAiSpendByUserSchema,
      }),
    // Re-sorting should not blank the table under the operator's cursor.
    placeholderData: (previous) => previous,
  });
}
